import { gql } from '@apollo/client'

export const GET_ADMIN_COMPANY_STORE_CATEGORIES = gql`
  query GetAdminCompanyStoreCategoriesById($input: CompanyStoresByIdsInput!) {
    companyStoresByIds(input: $input) {
      category
      id
    }
  }
`
